import { T } from "./tokens";

interface BigPlayButtonProps {
  isPlaying: boolean;
  loading: boolean;
  onToggle: () => void;
}

export function BigPlayButton({ isPlaying, loading, onToggle }: BigPlayButtonProps) {
  // Disabled only while a load is in flight; the initial "tap to start"
  // state (no track, not loading) is the round's first CTA and stays
  // clickable.
  const disabled = loading;
  return (
    <div
      style={{
        position: "relative",
        width: 196,
        height: 196,
        display: "grid",
        placeItems: "center",
        marginTop: 4,
      }}
    >
      {isPlaying &&
        [0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              border: `1.5px solid ${T.gold}55`,
              animation: `nig-pulse-ring 2.4s ${T.ease} ${i * 0.6}s infinite`,
            }}
          />
        ))}
      <svg
        width="196"
        height="196"
        viewBox="0 0 196 196"
        style={{ position: "absolute" }}
        aria-hidden
      >
        {[88, 80, 72, 64].map((r, i) => (
          <circle
            key={r}
            cx="98"
            cy="98"
            r={r}
            stroke={T.gold}
            strokeOpacity={0.12 + i * 0.04}
            fill="none"
            strokeDasharray={i === 0 ? "4 6" : undefined}
          />
        ))}
      </svg>
      <button
        onClick={onToggle}
        disabled={disabled}
        aria-label={isPlaying ? "Pause" : "Play"}
        className="nig-press nig-tap"
        style={{
          width: 110,
          height: 110,
          borderRadius: "50%",
          border: 0,
          background: `radial-gradient(circle at 35% 30%, ${T.goldGlow} 0%, ${T.gold} 60%, ${T.goldDeep} 100%)`,
          boxShadow: `${T.shadowGold}, inset 0 -4px 12px rgba(0,0,0,0.25), inset 0 2px 6px rgba(255,255,255,0.45)`,
          display: "grid",
          placeItems: "center",
          cursor: disabled ? "wait" : "pointer",
          position: "relative",
          animation: isPlaying ? "nig-rotate-slow 18s linear infinite" : "none",
          opacity: disabled ? 0.7 : 1,
        }}
      >
        {isPlaying ? (
          <div style={{ display: "flex", gap: 7 }}>
            <div style={{ width: 7, height: 32, background: T.navyDeep, borderRadius: 2 }} />
            <div style={{ width: 7, height: 32, background: T.navyDeep, borderRadius: 2 }} />
          </div>
        ) : (
          <svg width="34" height="38" viewBox="0 0 34 38" aria-hidden>
            <path d="M3 2 L31 19 L3 36 Z" fill={T.navyDeep} />
          </svg>
        )}
      </button>
    </div>
  );
}
